export default __webpack_public_path__ + "static/media/List-documentation.ad523caa.md";